var _class, _temp;

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import * as PropTypes from 'prop-types';
import AnnotationListProvider from '../../manifesto/AnnotationListProvider/AnnotationListProvider';
import AnnotationProvider from '../../manifesto/AnnotationProvider/AnnotationProvider';
import AnnotationRepresentation from '../AnnotationRepresentation/AnnotationRepresentation';

var AnnotationCanvasRepresentation = (_temp = _class = function (_Component) {
  _inherits(AnnotationCanvasRepresentation, _Component);

  function AnnotationCanvasRepresentation() {
    _classCallCheck(this, AnnotationCanvasRepresentation);

    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  AnnotationCanvasRepresentation.prototype.render = function render() {
    var _props = this.props,
        annotationStyle = _props.annotationStyle,
        growthStyle = _props.growthStyle,
        onClickAnnotation = _props.onClickAnnotation,
        bemModifiers = _props.bemModifiers,
        props = _objectWithoutProperties(_props, ['annotationStyle', 'growthStyle', 'onClickAnnotation', 'bemModifiers']);

    return React.createElement(
      AnnotationListProvider,
      props,
      React.createElement(
        AnnotationProvider,
        null,
        React.createElement(AnnotationRepresentation, {
          onClickAnnotation: onClickAnnotation,
          annotationStyle: annotationStyle,
          growthStyle: growthStyle,
          bemModifiers: bemModifiers
        })
      )
    );
  };

  return AnnotationCanvasRepresentation;
}(Component), _class.defaultProps = {
  annotationStyle: {}
}, _temp);
AnnotationCanvasRepresentation.propTypes = process.env.NODE_ENV !== "production" ? {
  annotationStyle: PropTypes.object,
  onClickAnnotation: PropTypes.func,
  growthStyle: PropTypes.oneOf(['fixed', 'scaled', 'absolute'])
} : {};


export default AnnotationCanvasRepresentation;